import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Global back button shown on all pages except the home page.
const BackButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === '/') return null;
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };
  return (
    <div className="w-full">
      <div className="mx-auto flex max-w-7xl justify-start px-5 pt-4">
        <button data-testid="global-back-btn" onClick={goBack} className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-4 py-1.5 text-sm font-medium text-[#1b4f72] shadow-sm transition-colors hover:bg-[#e9f3ec]">
          <ArrowLeft size={16} /> Back
        </button>
      </div>
    </div>
  );
};

export default BackButton;
